export default {
  init() {
    // Carousel nou start
    $('.carusel_next').click(function(){shiftSlide(1) })
    $('.carusel_prev').click(function(){shiftSlide(-1) })
    
    function shiftSlide(direction) {
      $(document).off('mouseup')
      setTimeout(function(){
        if (direction === 1) {
          $('.slide-product:first').before($('.slide-product:last'));
        } else if (direction === -1) {
          $('.slide-product:last').after($('.slide-product:first'));
        }
        setTimeout(function(){
          $('.slide-product').removeClass('carusel_next');
          $('.slide-product').removeClass('carusel_prev');
          $('.slide-product:last').addClass('carusel_prev');
          $('.slide-product:first').addClass('carusel_next');
          $('.slide-product').off('click');
          $('.carusel_next').click(function(){shiftSlide(1) })
          $('.carusel_prev').click(function(){shiftSlide(-1) })
        },10);
      },200)
    }
    //Carousel nou end
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/product.js